import React, { useState } from 'react';
import { message } from 'antd';
import Page from 'Component/common/udesk-qa-page-layout';
import { Container } from './components/Container';
import Filter from './components/Filter';
import { StatisticsCards } from './components/StatisticsCards';
import { ScoreCards } from './components/ScoreCards';
import { TrendChart } from './components/TrendChart';
import { ScoreTable } from './components/ScoreTable';
import { DataCard } from './components/DataCard';
import { postIntelligentCoursePartnerHomePageAdminStatisticsScores } from 'src/api/intelligentCoursePartner/homePage/admin/statisticsScores';
import { postIntelligentCoursePartnerHomePageAdminTaskDetail } from 'src/api/intelligentCoursePartner/homePage/admin/taskDetail';
import { postIntelligentCoursePartnerHomePageStudentTaskTrend } from 'src/api/intelligentCoursePartner/homePage/student/taskTrend';
import { postIntelligentCoursePartnerHomePageTaskRank } from 'src/api/intelligentCoursePartner/homePage/taskRank';
import './index.less';
import {
    IntelligentPartnerCourseHomePageAdminCourseSocresResponse,
    IntelligentPartnerHomePageCourseRank,
    IntelligentPartnerHomePageCourseScoresTrend,
    IntelligentPartnerHomePageAdminCourseDetailResponse,
} from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

const EvaluationOverview: React.FC = () => {
    // 状态管理
    const [loading, setLoading] = useState(false);
    const [filterParams, setFilterParams] = useState({});
    const [rankParams, setRankParams] = useState({
        rank: [
            {
                field: 1,
                order: 1,
            },
        ],
        listType: 1,
    });

    // 数据状态
    const [taskDetail, setTaskDetail] =
        useState<IntelligentPartnerHomePageAdminCourseDetailResponse>();
    const [scores, setScores] =
        useState<IntelligentPartnerCourseHomePageAdminCourseSocresResponse>();
    const [trends, setTrends] = useState<IntelligentPartnerHomePageCourseScoresTrend[]>([]);
    const [rankData, setRankData] = useState<IntelligentPartnerHomePageCourseRank[]>([]);

    // 加载所有数据
    const loadAllData = async (filterParams: any) => {
        setLoading(true);
        setFilterParams(filterParams);
        try {
            // 并行请求所有数据
            await Promise.all([
                postIntelligentCoursePartnerHomePageAdminStatisticsScores(filterParams).then(
                    (scoresRes) => {
                        setScores(scoresRes.data!);
                    }
                ),

                postIntelligentCoursePartnerHomePageAdminTaskDetail(filterParams).then(
                    (taskDetailRes) => {
                        setTaskDetail(taskDetailRes.data);
                    }
                ),

                postIntelligentCoursePartnerHomePageStudentTaskTrend(filterParams).then(
                    (trendRes) => {
                        setTrends(trendRes.data || []);
                    }
                ),

                postIntelligentCoursePartnerHomePageTaskRank({
                    ...filterParams,
                    ...rankParams,
                    systemModule: 0,
                }).then((rankRes) => {
                    setRankData(rankRes.data || []);
                }),
            ]);
        } catch (error) {
            message.error(
                /* 加载数据失败，请重试 */ UdeskLocales['current'].pages.coach.courseEvaluation
                    .overview.index.failedToLoadDataPleaseTryAgain
            );
            console.error('Data loading error:', error);
        } finally {
            setLoading(false);
        }
    };

    const loadRankData = (rankParams) => {
        setRankParams(rankParams);
        postIntelligentCoursePartnerHomePageTaskRank({
            ...filterParams,
            ...rankParams,
            systemModule: 0,
        }).then((rankRes) => {
            setRankData(rankRes.data || []);
        });
    };

    return (
        <Page
            pageBodyClassName="udesk-qa-web-coach-evaluation-overview-body"
            pageClassName="udesk-qa-web-coach-evaluation-overview"
            title={
                /* 评价总览 */ UdeskLocales['current'].pages.coach.courseEvaluation.overview.index
                    .evaluationOverview
            }
            padding={false}
            backGroundGhost={true}
        >
            <Container>
                <Filter onSubmit={(params: any) => loadAllData(params)} />
                <div className="content-layout">
                    <div className="data-section">
                        <DataCard
                            title={
                                /* 课程统计数据 */ UdeskLocales['current'].pages.coach
                                    .courseEvaluation.overview.index.courseStatistics
                            }
                            className="statistics-card"
                        >
                            <StatisticsCards loading={loading} data={taskDetail} />
                        </DataCard>
                        <DataCard
                            title={
                                /* 课程平均得分 */ UdeskLocales['current'].pages.coach
                                    .courseEvaluation.overview.index.averageCourseScore
                            }
                            className="score-card"
                        >
                            <ScoreCards loading={loading} data={scores} />
                        </DataCard>
                    </div>
                    <div className="trend-section">
                        <div className="trend-chart-section">
                            <div className="section-title">
                                {/* 评价趋势图 */}
                                {
                                    UdeskLocales['current'].pages.coach.courseEvaluation.overview
                                        .index.evaluationTrendChart
                                }
                            </div>
                            <TrendChart loading={loading} data={trends} />
                        </div>
                        <div className="score-table-section">
                            <ScoreTable loading={loading} onChange={loadRankData} data={rankData} />
                        </div>
                    </div>
                </div>
            </Container>
        </Page>
    );
};

export default EvaluationOverview;
